import React, { useMemo } from 'react';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import { Stack, Tooltip, useTheme, Skeleton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
// import { useGetUserTasksQuery } from '@/features/engagements/engagementsApi';
import { useSelector } from 'react-redux';
import InfoIcon from '@mui/icons-material/Info';
import { useGetUserDetailsQuery } from '@/features/user/userApi';
import { TaskIcon } from '@/components/icons/TaskIcon';
import { paths } from '@/app/routes';
import { endOfDay, getTime } from 'date-fns';
import { useListTasksQuery } from '@/features/engagements/engagementsApi';
import DashboardCard from '../DashboardCard';

const todayEnd = () => getTime(endOfDay(new Date()));

export const TasksDueCard = () => {
	const theme = useTheme();
	const navigate = useNavigate();

	const account = useSelector((state) => state.msalAccount.account);
	const email = account?.username;

	const { data: userDetails } = useGetUserDetailsQuery({ email }, { skip: !email });

	const userId = userDetails?.userId;
	const brokerGroupIds = userDetails?.brokerGroupArray;

	const { groupView } = useSelector((state) => state.userPrefs);

	const ownerFilter = groupView
		? `brokerGroupId: [${brokerGroupIds.join(',')}]`
		: `ownerDocId: [${userId}]`;

	const filters = useMemo(() => {
		const dateFilter = `completed:=false && dueDate:<${todayEnd()}`;

		return `${dateFilter} && ${ownerFilter}`;
	}, [ownerFilter]);

	const { isLoading, isUninitialized, ...tasksQuery } = useListTasksQuery(
		{ filters },
		{ skip: !userId },
	);
	const tasks = tasksQuery.data ?? [];

	const tasksDueCount = tasks.length || 0;

	const handleClick = () => navigate(paths.tasks);

	const total = useMemo(
		() =>
			isLoading || isUninitialized ? <Skeleton variant='text' width={50} /> : tasksDueCount,
		[isLoading, isUninitialized, tasksDueCount],
	);

	const title = (
		<Stack direction='row' alignItems={'center'}>
			<span>Tasks Due</span>
			<Tooltip title='Count of overdue tasks and tasks due today' placement='top' arrow>
				<InfoIcon
					sx={{
						fontSize: '16px',
						ml: 1,
						color: 'text.secondary',
					}}
				/>
			</Tooltip>
		</Stack>
	);

	return (
		<DashboardCard
			handleClick={handleClick}
			title={title}
			Icon={() => (
				<TaskIcon
					width='50px'
					height='50px'
					{...(theme.palette.mode === 'dark' && { bgColor: 'transparent' })}
				/>
			)}
			total={total}
		/>
	);
};
